import { render, staticRenderFns } from "./QueryRecord.vue?vue&type=template&id=1b6379d7&scoped=true"
import script from "./QueryRecord.vue?vue&type=script&lang=js"
export * from "./QueryRecord.vue?vue&type=script&lang=js"
import style0 from "./QueryRecord.vue?vue&type=style&index=0&id=1b6379d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6379d7",
  null
  
)

export default component.exports